import createIcon from '../../createIcon';

/**
 * @component @name CurrencyRuble
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSAzSDdWMTJINVYxNEg3VjE2SDVWMThIN1YyMUg5VjE4SDEzVjE2SDlWMTRIMTMuNUMxNi41NCAxNCAxOSAxMS41NCAxOSA4LjVDMTkgNS40NiAxNi41NCAzIDEzLjUgM1pNMTMuNSAxMkg5VjVIMTMuNUMxNS40MyA1IDE3IDYuNTcgMTcgOC41QzE3IDEwLjQzIDE1LjQzIDEyIDEzLjUgMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CurrencyRuble = createIcon('CurrencyRuble', [
  [
    'path',
    {
      d: 'M13.5 3H7V12H5V14H7V16H5V18H7V21H9V18H13V16H9V14H13.5C16.54 14 19 11.54 19 8.5C19 5.46 16.54 3 13.5 3ZM13.5 12H9V5H13.5C15.43 5 17 6.57 17 8.5C17 10.43 15.43 12 13.5 12Z',
      key: 'fus56x',
    },
  ],
]);

export default CurrencyRuble;
